import { UserAgreements } from '@interfaces/userAgreements';
import { fetcher } from '@utils/fetcher';

export const findTermsOfUseDetails = async (): Promise<UserAgreements> =>
  fetcher('/api/userAgreements/termsOfUse', {
    method: 'GET',
  });

export const findPrivacyPolicyDetails = async (): Promise<UserAgreements> =>
  fetcher('/api/userAgreements/privacyPolicy', {
    method: 'GET',
  });
